import axios from 'axios';
import { ConfigurationAuthorizationModel } from '@/types';
import { ConfigurationTreeNodeModel } from '@/types';

const ConfigurationApiUrl = 'configuration';

export const ConfigurationService = {
  async getConfigurationAuthorizationAsync(): Promise<ConfigurationAuthorizationModel> {
    const response = await axios.get(`${ConfigurationApiUrl}/authorization`);
    return response.data;
  },

  async getConfigurationTreeAsync(): Promise<ConfigurationTreeNodeModel> {
    const response = await axios.get(`${ConfigurationApiUrl}/tree`);
    return response.data;
  }
};
